import { VALIDATION_STATUS } from '~/constants/ValidationStatus'

/**
 * Debug helper for checkout flow testing.
 * Enable in browser console:
 *   enableCheckoutDebug()
 * or:
 *   localStorage.setItem('CHECKOUT_DEBUG', 'true')
 */
const isCheckoutDebugEnabled = () => {
  if (typeof window === 'undefined') {
    return false
  }

  if (window.CHECKOUT_DEBUG === true) {
    return true
  }

  try {
    return window.localStorage?.getItem('CHECKOUT_DEBUG') === 'true'
  } catch (_err) {
    return false
  }
}

export const isCheckoutMockOrderValidateEnabled = () => {
  return isCheckoutDebugEnabled()
}

export const getMockOrderValidateFailureResponse = () => {
  return {
    actionStatus: VALIDATION_STATUS.ERROR,
    hasErrors: true,
    hasSignupBlockingNotification: false,
    signupBlockingNotifications: []
  }
}

export const checkoutDebug = (...args) => {
  if (isCheckoutDebugEnabled()) {
    console.log('[Checkout]', ...args)
  }
}

export const enableCheckoutDebug = () => {
  if (typeof window === 'undefined') {
    return
  }
  window.CHECKOUT_DEBUG = true
  try {
    window.localStorage?.setItem('CHECKOUT_DEBUG', 'true')
  } catch (_err) {
    // ignore storage issues (private mode etc.)
  }
  console.log('[Checkout] Debug enabled. Opsummering validate will return a mock failure.')
}

export const disableCheckoutDebug = () => {
  if (typeof window === 'undefined') {
    return
  }
  window.CHECKOUT_DEBUG = false
  try {
    window.localStorage?.removeItem('CHECKOUT_DEBUG')
  } catch (_err) {
    // ignore storage issues (private mode etc.)
  }
  console.log('[Checkout] Debug disabled.')
}

if (typeof window !== 'undefined') {
  window.enableCheckoutDebug = enableCheckoutDebug
  window.disableCheckoutDebug = disableCheckoutDebug
}
